import React from "react";
import PropTypes from "prop-types";
import axios from "axios";
import { getChart, getChartV2, getDashboardViews, getChartStop, getSite } from "../../services/ConfigServices";
import UserService from "../../services/UserService";
import GridContainer from "../Grid/GridContainer";
import Card from "../Card/Card";
import CardHeader from "../Card/CardHeader";
import CardIcon from "../Card/CardIcon";
import CardBody from "../Card/CardBody";
import GridItem from "../Grid/GridItem";
import { DateMain } from "../../assets/jss/material-dashboard-pro-react/components/Analyses/CustomSelectDate";
import { getDateBeginDateEnd } from "./getDateBeginDateEnd";
import { selectDateOptionsNew } from "./DatesOptions";
import { FormControlLabel, TextField } from "@mui/material";
import Chip from "@mui/material/Chip";
import {
    Main,
    HeaderStyle,
    StyledSwitch,
    FormControlLabelStyle,
    SubmitDateButton,
    SubmitDateButtonStyle,
    FormControlStyle,
    ChooseDateStyle,
    CardContainerStyle,
    EntityTitleMain,
    HeaderDiv,
    CardBodyContainerStyle, InputChooseDateStyle, SelectDateMain, LoadingDiv, LoadingDivFull, cardHeaderStyle
} from "../../assets/jss/material-dashboard-pro-react/components/Analyses/CustomSelectHeader";
import chartsStyle from "../../assets/jss/material-dashboard-pro-react/views/chartsStyle";
import CheckIcon from '@mui/icons-material/Check';
import AdvancedSearchContext from "../../context/AdvancedSearchContext";
import { getChartCategoryScript } from "../Charts/getChartCategoryScript";
import ReactLoading from "react-loading";
// import { Dropdown, DropdownDivider, DropdownItem, DropdownMenu, } from "styled-dropdown-component";
// import { Button } from "styled-button-component";
import { withStyles } from "@mui/styles";
import TodayIcon from '@mui/icons-material/Today';
import LoopIcon from '@mui/icons-material/Loop';
import Masonry from 'react-masonry-css';
import 'assets/css/customMasonry.css';
import ChooseMultiGroupAnalyse from './ChooseMultiGroupAnalyse';
import moment from "moment";
import uuid from "react-uuid";
import { getChartCategoryScriptV2 } from "components/ChartV2/ChartV2";
import CustomSelect from "components/Input/CustomSelect.js";
import CustomSelectAnalyse from "components/Input/CustomSelectAnalyse.js";
import { isArray } from "lodash";

let dashboard = [];
let sources = [];
let chartrequestids = [];
let chartrequestidstostop = [];




class SelectingHeader extends React.Component {
    static contextType = AdvancedSearchContext;
    previousContext;

    constructor(props) {
        super(props);
        this.stopchart = false;
        this.state = {
            isCatHidden: true,
            isVueHidden: true,
            isDateHidden: true,
            isLoading: false,
            categories: [],
            categoriescampaign: [],
            selectedCategorie: "",
            selectedVue: "",
            selectedDateOption: "",
            vues: [],
            entityParameters: "",
            charts: [],
            chartsIds: [],
            dateBegin: "",
            dateEnd: "",
            displayingCharts: [],
            displayingTables: [],
            isSwitchChecked: false,
            displayAccording: [],
            column: null,
            multigroupchoice: false,
            multigroupmode: 'comparaison',
        };
        this.callInputDateCharts = this.callInputDateCharts.bind(this);
        this.getChart = this.getChart.bind(this);
    }
    componentDidMount() {
        chartrequestidstostop = [];
        this.previousContext = this.context;
        this.previousContext.chartIdGroup = this.context.chartIdGroup;
        this.getEntityParameters(this.context.chartIdGroup);
        axios.get(getDashboardViews(), {
            headers: {
                Authorization: `Bearer ${UserService.getToken()}`,
            },
        })
            .then((res) => {
                res.data.dashboard.AnalysePage.sort((a, b) => a.position - b.position);
                let category = [];
                res.data.dashboard.AnalysePage.map((page) => {
                    let cat = { name: page.name, id: page.uuid, views: page.views, type: "dashboard" };
                    category = category.concat(cat);
                    page.views.sort((a, b) => a.position - b.position);
                    return cat;
                });

                let categorycampaigns = [];
                if (res.data.dashboardcampaigns) {
                    categorycampaigns = res.data.dashboardcampaigns.map((page) => {
                        let option = {};
                        option.name = page.name;
                        option.id = page.id;
                        option.views = page.views;
                        option.type = 'campaign';
                        return option;
                    });
                }
                category = category.concat(categorycampaigns);

                const selectedDates = getDateBeginDateEnd(
                    selectDateOptionsNew[0].value
                );
                if (category.length > 0) {
                    this.setState({
                        categories: category,
                        selectedCategorie: category[0].id,
                        selectedDateOption: selectDateOptionsNew[0].value,
                        dateBegin: selectedDates.DateBegin,
                        dateEnd: selectedDates.DateEnd,
                        vues: this.getVues(
                            category[0],
                            selectedDates,
                            this.previousContext.chartIdGroup
                        ),
                    });
                }
                else {
                    this.setState({
                        categories: category,
                        selectedCategorie: '',
                        selectedDateOption: selectDateOptionsNew[0].value,
                        dateBegin: selectedDates.DateBegin,
                        dateEnd: selectedDates.DateEnd,
                        vues: []
                    });
                }
            });
    }


    componentDidUpdate() {
        if (this.previousContext.chartIdGroup !== this.context.chartIdGroup) {
            if (this.context.chartIdGroup) {
                if (Array.isArray(this.context.chartIdGroup[0]) && this.context.chartIdGroup[0].length > 1) {
                    this.setState({
                        multigroupchoice: true,
                        entityParameters: "",
                    });
                }
                else if (isArray(this.context.chartIdGroup) && this.context.chartIdGroup.length > 1 && !isArray(this.context.chartIdGroup[0])) { //ecriture différente en recherche avancée
                    this.setState({
                        multigroupchoice: true,
                        entityParameters: "",
                    });
                }
                else {
                    this.setState({
                        multigroupchoice: false,
                    });
                    let chartsC;
                    if (this.state.selectedVue) {
                        chartsC = this.state.vues.find(
                            (view) => this.state.selectedVue === view.id
                        );
                    }
                    this.getEntityParameters(this.context.chartIdGroup);
                    this.getChart(chartsC, "", this.context.chartIdGroup);

                }
            }
            this.previousContext.chartIdGroup = this.context.chartIdGroup;
            window.scrollTo(0, 0);
        }
    }
    componentWillUnmount() {
        for (let requestid of chartrequestids) {
            chartrequestidstostop.push(requestid);
        }
        for (let source of sources) {
            if (source) {
                source.cancel("Canceling");
            }
        }
        for (let requestid of chartrequestids) {
            axios.get(
                getChartStop(requestid),
                {
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                    },
                }
            )
                .then((response) => {
                })
                .catch((error) => {
                    console.error(error);
                });
        }
    }

    toggling = () => this.setState({ isCatHidden: !this.state.isCatHidden });
    togglingVue = () => this.setState({ isVueHidden: !this.state.isVueHidden });
    togglingDate = () => this.setState({ isDateHidden: !this.state.isDateHidden });
    onCategorieOptionClicked = (event) => {
        this.setState({
            selectedCategorie: event.target.value,
            isCatHidden: true,
        });
        this.getVues(this.state.categories.find((c) => c.id === event.target.value));
    };

    onVueOptionsClicked = (event) => {
        const viewselected = this.state.vues.find(
            (view) => view.id === event.target.value
        );

        console.log(viewselected);
        if (viewselected.type === 'campaign') {
            this.context.setChartIdGroup(Number(viewselected.campaigngroup));
            this.context.setOutofcontextclic(viewselected.campaigngroup);
            this.context.setSelectedNodesInfo(this.context.groupInfoListById["" + viewselected.campaigngroup]);
        }
        if (viewselected.datebegin && viewselected.dateend) {
            this.setState({
                selectedVue: viewselected.id,
                charts: this.getChart(viewselected, { DateBegin: viewselected.datebegin, DateEnd: viewselected.dateend }, this.context.chartIdGroup),
                column: Number(viewselected.column),
                dateEnd: viewselected.dateend,
                dateBegin: viewselected.datebegin,
                isSwitchChecked: true,
            });
        }
        else {
            this.setState({
                selectedVue: viewselected.id,
                charts: this.getChart(
                    viewselected,
                    "",
                    this.context.chartIdGroup
                ),
                column: Number(viewselected.column)
            });
        }
    };

    onOptionDateClicked = (event) => {
        let selectedDates = this.setSelectedDate(event.target.value);
        console.log(selectedDates);
        let selectedview = this.state.vues.find((view) => this.state.selectedVue === view.id);

        this.setState({
            isDateHidden: true,
            selectedDateOption: event.target.value,
            dateBegin: selectedDates.DateBegin,
            dateEnd: selectedDates.DateEnd,
            charts: this.getChart(selectedview, selectedDates, this.context.chartIdGroup),
            column: Number(selectedview.column),
        });
    };
    setSelectedDate = (value) => {
        return getDateBeginDateEnd(value);
    };
    handleChangeDateBegin = (event) => {
        let tmpdate = event.target.value;
        if (moment(tmpdate).isValid()) {
            this.setState({
                dateBegin: tmpdate,
            });
            if (moment(this.state.dateEnd).isBefore(moment(tmpdate))) {
                let tmpdateend = moment(tmpdate);
                this.setState({
                    dateEnd: tmpdateend.format("YYYY-MM-DD"),
                });
            }
        }

    };
    handleChangeDateEnd = (event) => {
        let tmpdate = event.target.value;
        if (moment(tmpdate).isValid()) {
            this.setState({
                dateEnd: tmpdate,
            });
            if (moment(this.state.dateBegin).isAfter(moment(tmpdate))) {
                let tmpdatebegin = moment(tmpdate);
                this.setState({
                    dateBegin: tmpdatebegin.format("YYYY-MM-DD"),
                });
            }
        }
    };
    handleChangeDateOptions = (event) => {
        this.setState({
            isSwitchChecked: event.target.checked,
        });
    };

    callInputDateCharts = () => {
        let selectedview = this.state.vues.find((view) => this.state.selectedVue === view.id);
        this.setState({
            charts: this.getChart(selectedview, "", this.context.chartIdGroup),
            displayingCharts: [],
        });
    }
    getEntityParameters = (chartIdGroup) => {
        axios
            .get(
                getSite(chartIdGroup, "parameters"),
                {
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                    },
                }
            )
            .then((res) => {
                this.setState({
                    entityParameters: res.data.detail,
                });
            })
            .catch(() => { });
    };
    getVues = (category, selectedDates, chartIdGroup) => {
        let vueOptions;
        let viewselected;
        console.log(category);
        if (category.type === 'dashboard') {
            vueOptions = category.views.map((view) => {
                return ({ id: view.uuid, charts: view.charts, name: view.viewName, column: view.column, datebegin: view.datebegin, dateend: view.dateend, type: 'dashboard' });
            });
            viewselected = vueOptions[0];
        }
        else if (category.type === 'campaign') {
            vueOptions = category.views.map((view) => {
                return ({
                    id: view.general.id, charts: view.charts, name: view.general.name, column: view.general.columns,
                    datebegin: view.general.datebegin, dateend: view.general.dateend, type: 'campaign', campaignid: view.campaignid, campaigngroup: view.general.groups
                });
            });
            viewselected = vueOptions[0];
            this.context.setChartIdGroup(Number(viewselected.campaigngroup));
            this.context.setOutofcontextclic(viewselected.campaigngroup);
            this.context.setSelectedNodesInfo(this.context.groupInfoListById["" + viewselected.campaigngroup]);
        }
        console.log(viewselected);
        if (viewselected.datebegin && viewselected.dateend) {
            this.setState({
                vues: vueOptions,
                selectedVue: viewselected.id,
                charts: this.getChart(viewselected, { DateBegin: viewselected.datebegin, DateEnd: viewselected.dateend }, this.context.chartIdGroup),
                column: Number(viewselected.column),
                dateEnd: viewselected.dateend,
                dateBegin: viewselected.datebegin,
                isSwitchChecked: true,
            });
        }
        else {
            this.setState({
                vues: vueOptions,
                selectedVue: viewselected.id,
                charts: this.getChart(
                    viewselected,
                    selectedDates,
                    this.context.chartIdGroup
                ),
                column: Number(viewselected.column)
            });
        }
        return vueOptions;
    };
    getVueOptions = (value) => {
        const option = dashboard.find((dashOpt) => value === dashOpt.name);
        return this.getVues(option);
    };

    getChartWithId = (index, viewtype, orderedChartsIds, idGroup, dateBegin, dateEnd, view, displayCharts, display, column) => {

        if (index >= orderedChartsIds.length)
            return;
        let chart = orderedChartsIds[index];
        const requestid = uuid();
        chartrequestids.push(requestid);
        let source = axios.CancelToken.source();
        let finalIndex = index;

        let chartsource = 'existing';
        if (viewtype === 'campaign') {
            chartsource = chart.source;
        }
        let url = '';
        if (chart.version && chart.version === 'v2') {
            if (viewtype === 'dashboard')
                url = getChartV2(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, '', requestid);
            else {
                url = getChartV2(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, view.id, requestid);
            }
        }
        else {
            if (viewtype === 'dashboard')
                url = getChart(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, '', '', '', '', '', '', '', requestid);
            else {
                if (chartsource === 'existing')
                    url = getChart(idGroup, chart.existingchart, dateBegin, dateEnd, this.state.multigroupmode, chartsource, '', '', '', '', '', '', '', requestid);
                else if (chartsource === 'definition')
                    url = getChart(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, chart.type, chart.granularity, chart.name, chart.definition, '', '', view.campaignid, requestid);
                else if (chartsource === 'point') {
                    if (chart.pointid)
                        url = getChart(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, chart.type, chart.granularity, chart.name, '', chart.pointid, '', '', requestid);
                    else if (chart.apppointid)
                        url = getChart(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, chart.type, chart.granularity, chart.name, '', '', chart.apppointid, '', requestid);
                }
            }
        }

        sources.push(source);
        axios.get(
            url,
            {
                headers: {
                    Authorization: `Bearer ${UserService.getToken()}`,
                },
                cancelToken: source.token,
            }
        )
            .then((response) => {
                chart.serverData = response.data.chart;
                if (chart.serverData.version === 'v1') {
                    return [chart].map((elt) => {
                        displayCharts = getChartCategoryScript(
                            elt.serverData?.data,
                            elt.serverData?.title,
                            elt.serverData?.category,
                            elt.serverData?.type,
                            elt.serverData?.stacking,
                            elt.position,
                            chart.id,
                        );
                        display = this.state.displayingCharts;
                        display[finalIndex] = displayCharts;
                        let dispAccording = this.displayAccordingCol(display, column);
                        this.setState({
                            displayingCharts: display,
                            displayAccording: dispAccording,
                            isLoading: false,
                        });
                        const indexsplice = chartrequestids.indexOf(requestid);
                        if (indexsplice > -1) {
                            chartrequestids.splice(indexsplice, 1);
                        }
                        return null;
                    });

                }
                else {
                    displayCharts = getChartCategoryScriptV2(chart.serverData, chart.id, this.state.entityParameters);
                    display = this.state.displayingCharts;
                    display[finalIndex] = displayCharts;
                    let dispAccording = this.displayAccordingCol(display, column);
                    this.setState({
                        displayingCharts: display,
                        displayAccording: dispAccording,
                        isLoading: false,
                    });
                    const indexsplice = chartrequestids.indexOf(requestid);
                    if (indexsplice > -1) {
                        chartrequestids.splice(indexsplice, 1);
                    }

                }

            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {

                if (chartrequestidstostop.includes(requestid)) {

                    this.stopchart = false;
                    return;
                }
                if (this.stopchart) {

                }
                index++;
                this.getChartWithId(index, viewtype, orderedChartsIds, idGroup, dateBegin, dateEnd, view, displayCharts, display, column);
            });

    }

    getChart = (view, selectedDates, idGroup) => {

        console.log(view);
        let column = Number(view.column);
        let viewtype = 'dashboard';
        if (view.type === 'campaign') {
            viewtype = 'campaign';
        }
        for (let requestid of chartrequestids) {
            chartrequestidstostop.push(requestid);

        }
        for (let source of sources) {
            if (source) {
                source.cancel("Canceling");
            }
        }
        for (let requestid of chartrequestids) {
            axios.get(
                getChartStop(requestid),
                {
                    headers: {
                        Authorization: `Bearer ${UserService.getToken()}`,
                    },
                }
            )
                .then((response) => {
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        chartrequestids = [];
        sources = [];
        let chartsIds = [];
        let maxPos = 0;
        let orderedChartsIds = [];
        let dateBegin = this.state.dateBegin;
        let dateEnd = this.state.dateEnd;
        let displayCharts;
        let display = [];
        let disp = [];
        let index = 0;


        if (selectedDates) {
            dateBegin = selectedDates.DateBegin;
            dateEnd = selectedDates.DateEnd;
        }
        chartsIds = chartsIds.concat(view.charts);

        for (const element of chartsIds) {
            if (element.position && element.position > maxPos)
                maxPos = element.position;
        }
        for (let i = 1; i <= maxPos; i++) {
            for (const element of chartsIds) {
                if (element.position && element.position === i)
                    orderedChartsIds.push(element);
            }
        }

        for (const chart of orderedChartsIds) {
            let chartLoading = (
                <Card raised={true} chart>
                    <CardHeader color="info" icon style={cardHeaderStyle}>
                        <CardIcon color="info">
                            <LoopIcon />
                        </CardIcon>
                        <h4 style={chartsStyle.cardIconTitle}>
                            En cours de chargement...
                        </h4>
                        <div style={{ height: "5px", width: "5px" }}></div>
                    </CardHeader>
                    <CardBody>
                        <div>
                            <LoadingDiv>
                                <ReactLoading
                                    type={"bars"}
                                    color={"#91c241"}
                                    height={"15%"}
                                    width={"15%"}
                                />
                            </LoadingDiv>
                        </div>

                    </CardBody>
                </Card>

            );
            disp = disp.concat([chartLoading]);
        }
        this.setState({
            displayingCharts: disp,
        });
        this.setState({
            isLoading: true,
        })
        this.getChartWithId(index, viewtype, orderedChartsIds, idGroup, dateBegin, dateEnd, view, displayCharts, display, column);
    };

    /*   getChart = (view, selectedDates, idGroup) => {
           let column = view.column;
           let viewtype = 'dashboard';
           if (view.general) {
               viewtype = 'campaign';
               column = Number(view.general.columns);
           }
           for (let source of sources) {
               if (source) {
                   source.cancel("Canceling");
               }
           }
           for (let requestid of chartrequestids) {
               axios.get(
                   getChartStop(requestid),
                   {
                       headers: {
                           Authorization: `Bearer ${UserService.getToken()}`,
                       },
                   }
               )
                   .then((response) => {
                   })
                   .catch((error) => {
                       console.error(error);
                   });
           }
           chartrequestids = [];
           sources = [];
           let chartsIds = [];
           let maxPos = 0;
           let orderedChartsIds = [];
           let dateBegin = this.state.dateBegin;
           let dateEnd = this.state.dateEnd;
           let displayCharts;
           let display = [];
           let displayAccording;
           let disp = [];
           let index = 0;
   
   
           if (selectedDates) {
               dateBegin = selectedDates.DateBegin;
               dateEnd = selectedDates.DateEnd;
           }
           chartsIds = chartsIds.concat(view.charts);
   
           for (const element of chartsIds) {
               if (element.position && element.position > maxPos)
                   maxPos = element.position;
           }
           for (let i = 1; i <= maxPos; i++) {
               for (const element of chartsIds) {
                   if (element.position && element.position === i)
                       orderedChartsIds.push(element);
               }
           }
   
           for (const chart of orderedChartsIds) {
               let chartLoading = (
   
                   <Card raised={true} chart>
                       <CardHeader color="info" icon style={cardHeaderStyle}>
                           <CardIcon color="info">
                               <LoopIcon />
                           </CardIcon>
                           <h4 style={chartsStyle.cardIconTitle}>
                               En cours de chargement...
                           </h4>
                           <div style={{ height: "5px", width: "5px" }}></div>
                       </CardHeader>
                       <CardBody>
                           <div>
                               <LoadingDiv>
                                   <ReactLoading
                                       type={"bars"}
                                       color={"#91c241"}
                                       height={"15%"}
                                       width={"15%"}
                                   />
                               </LoadingDiv>
                           </div>
   
                       </CardBody>
                   </Card>
   
               );
               disp = disp.concat([chartLoading]);
           }
           this.setState({
               displayingCharts: disp,
           });
           this.setState({
               isLoading: true,
           })
   
   
           for (const chart of orderedChartsIds) {
               const requestid = uuid();
               chartrequestids.push(requestid);
               let source = axios.CancelToken.source();
               let finalIndex = index;
   
               let chartsource = 'existing';
               if (viewtype === 'campaign') {
                   chartsource = chart.source;
               }
               let url = '';
               if (viewtype === 'dashboard')
                   url = getChart(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, '', '', '', '', '', '', requestid);
               else {
                   if (chartsource === 'existing')
                       url = getChart(idGroup, chart.existingchart, dateBegin, dateEnd, this.state.multigroupmode, chartsource, '', '', '', '', '', '', requestid);
                   else if (chartsource === 'definition')
                       url = getChart(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, chart.type, chart.granularity, chart.name, chart.definition, '', view.campaignid, requestid);
                   else if (chartsource === 'point')
                       url = getChart(idGroup, chart.id, dateBegin, dateEnd, this.state.multigroupmode, chartsource, chart.type, chart.granularity, chart.name, '', chart.pointid, '', requestid);
               }
               sources.push(source);
               axios.get(
                   url,
                   {
                       headers: {
                           Authorization: `Bearer ${UserService.getToken()}`,
                       },
                       cancelToken: source.token,
                   }
               )
                   .then((response) => {
                       chart.serverData = response.data.chart;
                       return [chart].map((elt) => {
                           displayCharts = getChartCategoryScript(
                               elt.serverData?.data,
                               elt.serverData?.title,
                               elt.serverData?.category,
                               elt.serverData?.type,
                               elt.serverData?.stacking,
                               elt.position,
                               chart.id,
                           );
                           display = this.state.displayingCharts;
                           display[finalIndex] = displayCharts;
                           let dispAccording = this.displayAccordingCol(display, column);
                           this.setState({
                               displayingCharts: display,
                               displayAccording: dispAccording,
                               isLoading: false,
                           });
                           const indexsplice = chartrequestids.indexOf(requestid);
                           if (indexsplice > -1) {
                               chartrequestids.splice(indexsplice, 1);
                           }
                       });
                   })
                   .catch((error) => {
                       console.error(error);
                   });
               index++;
   
           }
       };
   */



    displayAccordingCol = (displayingCharts, columns) => {
        let result = [];
        let index = 0;
        while (index < displayingCharts.length) {
            if (index % columns === 0) result.push([]);
            result[result.length - 1].push(displayingCharts[index++])
        }
        return result;
    }
    gridByColumn = (column, element, index) => {
        // let grid = null;
        if (column === 1) {
            return (<GridItem xs={12} key={`xs12_chartgrid_${index}`}> {element} </GridItem>);
        } else if (column === 2) {
            return (<GridItem xs={6} key={`xs12_chartgrid_${index}`}> {element} </GridItem>);
        } else if (column === 3) {
            return (<GridItem xs={4} key={`xs12_chartgrid_${index}`}> {element} </GridItem>);
        } else if (column === 4) {
            return (<GridItem xs={3} key={`xs12_chartgrid_${index}`}> {element} </GridItem>);
        }
        //return grid;
    }

    handleChooseMultiGroupLaunch = () => {
        this.setState({
            multigroupchoice: false,
        });
        let selectedview;
        if (this.state.selectedVue) {
            selectedview = this.state.vues.find((view) => this.state.selectedVue === view.id);
        }
        this.getChart(selectedview, "", this.context.chartIdGroup);
        window.scrollTo(0, 0);
    }

    handleMultiGroupChoice = (e) => {
        this.setState({
            multigroupmode: e.target.value,
        });
    }

    render() {
        return (
            <div>
                <HeaderDiv style={HeaderStyle}>
                    <Main>
                        <CustomSelectAnalyse
                            marginTop={15}
                            width={200}
                            inputTitle={"Catégorie"}
                            selectValue={this.state.selectedCategorie}
                            handleSelectValueChange={this.onCategorieOptionClicked}
                            data={this.state.categories}
                            small
                        />
                        <CustomSelectAnalyse
                            marginTop={15}
                            width={200}
                            inputTitle={"Vue"}
                            selectValue={this.state.selectedVue}
                            handleSelectValueChange={this.onVueOptionsClicked}
                            data={this.state.vues}
                            small
                        />
                    </Main>
                    <Chip label={this.context.selectedNodesInfo} style={EntityTitleMain} />
                    <DateMain>
                        {this.state.isSwitchChecked === false ? (
                            <SelectDateMain >
                                <CustomSelect
                                    marginTop={15}
                                    width={200}
                                    inputTitle={"Dates"}
                                    selectValue={this.state.selectedDateOption}
                                    handleSelectValueChange={this.onOptionDateClicked}
                                    data={selectDateOptionsNew}
                                    small
                                />
                            </SelectDateMain>
                        ) : (
                            <DateMain style={{ marginBottom: '-8px' }}>
                                <React.Fragment>
                                    <TextField
                                        id="dateBegin"
                                        label="Date de début"
                                        type="date"
                                        //defaultValue={this.state.dateBegin}
                                        value={this.state.dateBegin}
                                        onChange={this.handleChangeDateBegin}
                                        InputLabelProps={{
                                            shrink: true,
                                            "aria-describedby": "starting date input",
                                            style: InputChooseDateStyle
                                        }}
                                        inputProps={{
                                            style: ChooseDateStyle,
                                        }}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        margin="normal"
                                        variant="filled"
                                        size={"small"}
                                        style={{
                                            marginRight: "14px",
                                            boxShadow: "grey 0px 1px 4px 0px",
                                            marginBottom: "0px"
                                        }}
                                    />

                                    <TextField
                                        id="dateEnd"
                                        label="Date de fin"
                                        type="date"
                                        //defaultValue={this.state.dateEnd}
                                        value={this.state.dateEnd}
                                        onChange={this.handleChangeDateEnd}
                                        InputLabelProps={{
                                            shrink: true,
                                            "aria-describedby": "ending date input",
                                            style: InputChooseDateStyle
                                        }}
                                        inputProps={{
                                            style: ChooseDateStyle
                                        }}
                                        InputProps={{
                                            disableUnderline: true
                                        }}
                                        margin="normal"
                                        variant="filled"
                                        size={"small"}
                                        style={{
                                            boxShadow: "grey 0px 1px 4px 0px",
                                            marginBottom: "0px"
                                        }}
                                    />
                                    <SubmitDateButton onClick={this.callInputDateCharts} style={SubmitDateButtonStyle}>
                                        <CheckIcon />
                                    </SubmitDateButton>
                                </React.Fragment>
                            </DateMain>
                        )}
                        <FormControlLabel
                            style={FormControlStyle}
                            control={
                                <StyledSwitch
                                    checked={this.state.isSwitchChecked}
                                    color={"secondary"}
                                    name={"choosing-date"}
                                    onChange={this.handleChangeDateOptions}
                                    inputProps={{
                                        "aria-label": "choisir une date",
                                    }}
                                    icon={<TodayIcon style={{
                                        fill: "white",
                                        fontSize: "20px",
                                        marginTop: "5px",
                                    }} />}
                                    checkedIcon={<TodayIcon style={{
                                        fill: "white",
                                        fontSize: "20px",
                                        marginTop: "5px",
                                    }} />}
                                />
                            }

                        />
                    </DateMain>
                </HeaderDiv>
                <GridContainer>
                    <Card style={CardContainerStyle}>
                        {this.state.multigroupchoice ?
                            <GridContainer>
                                <GridItem xs={0} sm={4} md={4} lg={4}></GridItem>
                                <GridItem xs={12} sm={4} md={4} lg={4}>
                                    <ChooseMultiGroupAnalyse
                                        handleChooseMultiGroupLaunch={this.handleChooseMultiGroupLaunch}
                                        handleMultiGroupChoice={this.handleMultiGroupChoice}
                                        multigroupmode={this.state.multigroupmode}
                                        selectioncount={this.context?.chartIdGroup?.length}
                                    />
                                </GridItem>
                                <GridItem xs={0} sm={4} md={4} lg={4}></GridItem>
                            </GridContainer>
                            :
                            this.state.isLoading === true ? (
                                <div>
                                    <LoadingDivFull>
                                        <ReactLoading
                                            type={"bars"}
                                            color={"#91c241"}
                                            height={"20%"}
                                            width={"20%"}
                                        />
                                    </LoadingDivFull>
                                </div>
                            ) : (
                                <CardBody style={CardBodyContainerStyle}>
                                    {/* <FullScreenView backgroundColor="#efefef"> */}
                                    {/* <GridContainer spacing={2} style={ChartContainerGrid}> */}
                                    <div>

                                        <Masonry
                                            breakpointCols={{
                                                default: this.state.column,
                                                1100: this.state.column > 1 ? (this.state.column - 1) : this.state.column,
                                                700: 1,
                                                500: 1
                                            }
                                            }
                                            className="my-masonry-grid"
                                            columnClassName="my-masonry-grid_column">
                                            {this.state.displayAccording.map((charts, index) => {

                                                return charts.map((chart, index2) => {
                                                    return (<div>
                                                        {chart}
                                                    </div>)
                                                    // return (this.gridByColumn(this.state.column, chart, index));
                                                })
                                            })}
                                            {/* </GridContainer> */}
                                        </Masonry>
                                    </div>
                                    {/* </FullScreenView> */}
                                </CardBody>
                            )}
                    </Card>
                </GridContainer>
            </div>
        );
    }
}

SelectingHeader.propTypes = {
    categories: PropTypes.array,
};
export default withStyles(FormControlLabelStyle)(SelectingHeader);
